import { SCREEN_BREAKPOINTS, ScreenSizeType } from '../../models';

export function getScreenSizeType(width: number): ScreenSizeType {
  if (width >= SCREEN_BREAKPOINTS[ScreenSizeType.SuperExtraLarge]) {
    return ScreenSizeType.SuperExtraLarge;
  }

  if (width >= SCREEN_BREAKPOINTS[ScreenSizeType.ExtraLarge]) {
    return ScreenSizeType.ExtraLarge;
  }

  if (width >= SCREEN_BREAKPOINTS[ScreenSizeType.Large]) {
    return ScreenSizeType.Large;
  }

  if (width >= SCREEN_BREAKPOINTS[ScreenSizeType.Medium]) {
    return ScreenSizeType.Medium;
  }

  if (width >= SCREEN_BREAKPOINTS[ScreenSizeType.Small]) {
    return ScreenSizeType.Small;
  }

  return ScreenSizeType.ExtraSmall;
}
